import type * as Types from '../../../schemas/shopify/admin.types';

import { CollectionAnalyticPageInfoNodeFragmentDoc } from '../fragments/pageAnalyticCollectionInfo.generated';
import { ArticleAnalyticPageInfoNodeFragmentDoc } from '../fragments/pageAnalyticArticleInfo.generated';
import { ProductAnalyticPageInfoNodeFragmentDoc } from '../fragments/pageAnalyticProductInfo.generated';
import { PageAnalyticPageInfoNodeFragmentDoc } from '../fragments/pageAnalyticPageInfo.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcherGemX } from '../../utils/gatewayClientGemX';
export type GetPagesInfoByIdsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']>;
}>;

export type GetPagesInfoByIdsQueryResponse = {
  nodes: Array<
    Types.Maybe<
      | (Pick<Types.Article, 'id' | 'title' | 'handle'> & { blog: Pick<Types.Blog, 'handle'> })
      | Pick<Types.Collection, 'id' | 'title' | 'handle'>
      | Pick<Types.Page, 'id' | 'title' | 'handle'>
      | Pick<Types.Product, 'id' | 'title' | 'handle'>
      | {}
    >
  >;
};

export const GetPagesInfoByIdsDocument = `
    query getPagesInfoByIds($ids: [ID!]!) {
  nodes(ids: $ids) {
    ...ArticleAnalyticPageInfoNode
    ...CollectionAnalyticPageInfoNode
    ...PageAnalyticPageInfoNode
    ...ProductAnalyticPageInfoNode
  }
}
    ${ArticleAnalyticPageInfoNodeFragmentDoc}
${CollectionAnalyticPageInfoNodeFragmentDoc}
${PageAnalyticPageInfoNodeFragmentDoc}
${ProductAnalyticPageInfoNodeFragmentDoc}`;

export const useGetPagesInfoByIdsQuery = <TData = GetPagesInfoByIdsQueryResponse, TError = unknown>(
  variables: GetPagesInfoByIdsQueryVariables,
  options?: UseQueryOptions<GetPagesInfoByIdsQueryResponse, TError, TData>,
) => {
  return useQuery<GetPagesInfoByIdsQueryResponse, TError, TData>(
    ['getPagesInfoByIds', variables],
    appFetcherGemX<GetPagesInfoByIdsQueryResponse, GetPagesInfoByIdsQueryVariables>(
      GetPagesInfoByIdsDocument,
      variables,
    ),
    options,
  );
};

useGetPagesInfoByIdsQuery.getKey = (variables: GetPagesInfoByIdsQueryVariables) => [
  'getPagesInfoByIds',
  variables,
];
